import script from "./FontSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FontSelect.vue?vue&type=style&index=0&id=146b1341&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146b1341"]])

export default __exports__